import { FoldingCube } from './FoldingCube';

interface FullPageLoaderProps {
  text?: string;
}

function FullPageLoader({ text = 'Loading...' }: FullPageLoaderProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <FoldingCube size="lg" text={text} />
    </div>
  );
}

export { FullPageLoader };
export type { FullPageLoaderProps };
